// "Production" enabled environment

export const environment = {
    production: false,
    showDevUsage: false,
    // envName: 'dev',
    appConfig: 'appconfig.json',
    GoogleTag: 'GTM-MPWF8FGT',
    GoogleClientId: '879001635616-ktqpsf12bbi55kh4ut8auvuio28bk0so.apps.googleusercontent.com',
    FacebookClientId: '3721145298155846',
    RecaptchSiteKey: "6LdH5FspAAAAADw0kIW5v05ZxicwYRu5Xe2g7tNE",
    ClickConnectorPaidUsersWidgetId: "4d9580-b1eea",
    ClickConnectorFreeUsersWidgetId: "4d9580-8a5bb",
    ServicesBaseUrl: "https://services.cablepro.elek.com",
    WebFacingHost: "calculators.dev.cablepro.elek.com",
    LoginCookieDomain: '.dev.cablepro.elek.com',
    token: 'ZXvAKmvgrTYOkVais5rt0Ks88YLaCYRTvhPeS0rrFOgMZPsOYVtblvsXz7T3IQjS',
    ckEditorLicenceKey: 'eyJhbGciOiJFUzI1NiJ9.eyJleHAiOjE3Nzg4ODk1OTksImp0aSI6IjdjZDY1NDVmLWUwNjctNDY5My05Yzg2LTJiY2E2NTVmMDJmOCIsImxpY2Vuc2VkSG9zdHMiOlsiMTI3LjAuMC4xIiwibG9jYWxob3N0IiwiMTkyLjE2OC4qLioiLCIxMC4qLiouKiIsIjE3Mi4qLiouKiIsIioudGVzdCIsIioubG9jYWxob3N0IiwiKi5sb2NhbCJdLCJ1c2FnZUVuZHBvaW50IjoiaHR0cHM6Ly9wcm94eS1ldmVudC5ja2VkaXRvci5jb20iLCJkaXN0cmlidXRpb25DaGFubmVsIjpbImNsb3VkIiwiZHJ1cGFsIl0sImxpY2Vuc2VUeXBlIjoiZGV2ZWxvcG1lbnQiLCJmZWF0dXJlcyI6WyJEUlVQIl0sInZjIjoiNDYxNGY0MWIifQ.Nq6oDlQKCVwFhkBAegGRvZX8Y-mNUiOy8jy8N15_y5kc5ZSbZ9XP0PtWPL53Q-8XIIdVKuZsCojMBn9EOob4MA',
    RollbarAccessToken: "72bfc40e4dae4681a177987fe92dfe8f259dde6934fa3570b241948272b99c0101a2fc5386491f89f81f72bb38654e1e",
    RollbarErrorEnviornment: "devserver",
    posthogKey: "phc_TUGg6YMudJtlr3VT60ux6laBVZlyq7IJBbWd9cX0dkv",
    posthogHost: "https://us.i.posthog.com",
    enableRollbar: false,
    enablePosthog: false
};
